import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 4l-8 4l8 4l8 -4l-8 -4","key":"svg-0"}],["path",{"d":"M4 12l8 4l8 -4","key":"svg-1"}],["path",{"d":"M4 16l8 4l8 -4","key":"svg-2"}]]

const IconStack2 = createReactComponent('outline', 'stack-2', 'Stack2', __iconNode);

export default IconStack2;